import React from 'react';

const ConfirmEndModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">

      <div className="bg-black p-6 rounded-lg max-w-sm border border-[#c59ad1e6]">
        <h2 className="text-xl font-bold mb-4">End Conversation</h2>
        <p className="mb-4">Are you sure you want to end the conversation? This action cannot be undone.</p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-[#93779b] text-white rounded hover:bg-[#c59ad1e6]"
          >
            End Conversation
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmEndModal;